import React from 'react';
import { Route } from 'react-router-dom';
import { BlogPage } from './BlogPage';

export const routes = [<Route key="0" path="/blog" component={BlogPage} />];

export const navigation = [{ name: 'Blog', link: '/blog', icon: 'Blog' }];
